import AnalyticsList from "./analytics/AnalyticsList";
import AnalyticsPage from "./analytics/AnalyticsPage";
import ConversationList from "./conversation/ConversationList";
import OptOutList from "./optOuts/OptOutList";
import WithheldDestinationList from "./withheldDestinations/WithheldDestinationList";
const rootSupervision = "company/:company/supervision/";
const routes = [
    {path : rootSupervision + 'conversations/list', component : () => <ConversationList/>, isSidebar : true, isPublic : false , permissions:['view_conversations']},
    {path : rootSupervision + 'optouts/list', component : () => <OptOutList/>, isSidebar : true, isPublic : false , permissions:['view_conversations']},
    {path : rootSupervision + 'withheld-destinations/list', component : () => <WithheldDestinationList/>, isSidebar : true, isPublic : false , permissions:['view_conversations']},
    {path : rootSupervision + 'analytics/list', component: () => <AnalyticsList/>, isPublic : false, isSidebar : true , permissions:['view_analytics']},
    {path : rootSupervision + 'analytics/:bot', component: () => <AnalyticsPage/>, isPublic : false, isSidebar : true},
]

export default routes;